/* eslint-disable no-debugger */
import { useContext } from 'react';

import { VccSeasonStateContext } from './VccSeasonContextProvider';

import VccSeasonData from './VccSeasonData';

const useVccSeasonData = () => {
  const [vccSeasonState, setVccSeasonState] = useContext(VccSeasonStateContext);

  const getVccSeasons = () => VccSeasonData.getVccSeasonData(vccSeasonState, setVccSeasonState);

  return {
    vccSeasonState,
    getVccSeasons
  };
};

export default useVccSeasonData;